import {
  Button,
  CardContent,
  CircularProgress,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  checkEParavoloAVathmias,
  checkEParavoloBVathmias,
  educationLevel,
  eParavoloAVathmias,
  eParavoloBVathmias,
  FINISHED,
  gender,
  INITIAL_SUBMIT,
  MEDICAL_A_DEGREE_REJECTION,
  NOONE_SIDE,
  REJECTED_FROM_CITIZEN,
  APPROVED_AWAITING_COLLECTION,
  RESUBMITTED,
  retiredOptions,
  REVIEW,
  SERVICE_SIDE,
  TEMPORARILY_SAVED,
} from "../../../constants";
import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { useMutation, useQuery } from "react-query";

import { Alert } from "@material-ui/lab";
import ApplicantDetails from "../new application/ApplicantDetails";
import ConfirmationModal from "./ConfirmationModal";
import CustomAlert from "../../components/CustomAlert";
import { Formik } from "formik";
import { Helmet } from "react-helmet-async";
import PostponeModal from "./PostponeModal";
import SeeHistory from "./SeeHistory";
import SeeReferrals from "./SeeReferrals";
import SuccessScreen from "../new application/SuccessScreen";
import UploadedDocuments from "./UploadedDocuments";
import dayjs from "dayjs";
import { fetchApplicationDocumentsExternalUser } from "../../../services/applicationDocuments";
import { fetchApplicationHistoryExternalUser } from "../../../services/applicationsHistory";
import { fetchApplicationWithIdExternalUser } from "../../../services/applicationsService";
import { fetchDocPerSpecificKind } from "../../../services/documentsPerKindService";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import { updateApplication } from "../../../services/applicationsService";
import useLocale from "../../../hooks/useLocale";
import { useSelector } from "react-redux";
import { documentsRequiredFiltered } from "../../../utils/nauticalPdcolorFn";
import GovGrTabs from "../../../components/GovGrTabs";
import GovGrButton from "../../../components/GovGrButton";
import getValidationSchemaForMe from "./validationSchemas/validationSchemaForMe";
import getValidationSchemaForOther from "./validationSchemas/validationSchemaForOther";
import generateInitialValues from "./generateInitialValues";
import onSubmit from "./submit function/onSubmit";
import GovGrErrorSummary from "../../../components/GovGrErrorSummary";
import { fetchPrfcsForExternalUser } from "../../../services/prfcsService";
import { fetchPortAuthoritiesForExternalUser } from "../../../services/portAuthoritiesService";
import { fetchBirthCountry } from "../../../services/birthCountryService";
import Eparavolo from "./eParavolo";
import { getIsEParavoloPliromeno } from "../../../utils/errorMessage";
import EParavoloContentProvider, {
  EParavoloContext,
} from "../../../context/eParavoloContext";
import { useContext } from "react";
import localStorage from "local-storage";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Card = styled(MuiCard)(spacing);

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    minWidth: 500,
    maxWidth: "20vw",
    marginBottom: "1.2rem",
    marginRight: "1.2rem",
  },
  cardsSpace: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  controlsContainer: {
    margin: "10px 0",
    border: "1px solid rgb(204,204,204)",
  },
  buttonContainer: {
    padding: "20px",
  },
  cancelButton: {
    color: "red",
  },
  submitButton: {
    padding: "10px 100px",
  },
  commentInput: {
    width: "100%",
  },
  applicationCard: {},
  loading: {
    display: "flex",
    justifyContent: "center",
    height: 400,
    alignItems: "center",
  },
  contentCard: {
    display: "inline-flex",
  },
  insideContentMargin: {
    marginRight: "2rem",
  },
}));

const EditApplication = (props) => {
  const { t } = useLocale();
  const [statusAppl, setStatusAppl] = useState(0);
  const [info, setInfo] = useState("");
  const user = useSelector((state) => state?.authReducer?.user);
  const [error, setError] = useState("");
  const [, setProtocolNumber] = useState("");
  const [isPostponeModalOpen, setIsPostponeModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [documentsFiltered, setDocumentsFiltered] = useState([]);
  const [nauticalPdColor] = useState(() => localStorage.get("nauticalPdColor"));
  const { paravoloStatus } = useContext(EParavoloContext);

  const { data: PrfcsData } = useQuery("prfcs", fetchPrfcsForExternalUser);
  const { data: PortAuthoritiesData } = useQuery(
    "portAuthorities",
    fetchPortAuthoritiesForExternalUser
  );
  const {
    // application id
    state: { id },
  } = useLocation();

  const TranslatedRetiredOptions = retiredOptions?.map((option) => {
    return { id: option.id, dscr: t(`${option.dscr}`) };
  });

  const TranslatedEducationLevel = educationLevel?.map((option) => {
    return { id: option.id, dscr: t(`${option.dscr}`) };
  });
  const translatedGender = gender?.map((option) => ({
    ...option,
    dscr: t(`${option.dscr}`),
  }));

  const { data: history } = useQuery(
    ["applicationHistoryWithIdExternalUser", id],
    () => fetchApplicationHistoryExternalUser(id)
  );

  const classes = useStyles();

  const { mutate } = useMutation(updateApplication, {
    onSuccess: (data) => {
      setStatusAppl(RESUBMITTED);
      setProtocolNumber(data?.data);
    },
    onError: (error) => {
      setError(error.response.data);
    },
  });

  const {
    data: applicationData,
    isLoading: isLoadingApplication,
    refetch: refetchUserApplicationData,
  } = useQuery(["application", id], () =>
    fetchApplicationWithIdExternalUser(id)
  );

  useEffect(() => {
    // console.log("EDIT");
    if (applicationData?.[0]?.status === MEDICAL_A_DEGREE_REJECTION) {
      setInfo(
        t(
          "Your A' dregree medical document has been rejected, if you want to apply for review of the decision please download the review referral from referrals tabs, fill the missing fields and upload it on documents tabs at review document"
        )
      );
    }
  }, [applicationData]);

  const { data: fetchBirthCountries } = useQuery(
    "fetchBirthCountries",
    fetchBirthCountry
  );

  const { data: docsPerKind } = useQuery(
    "docPerKindSpecificEdit",
    () => fetchDocPerSpecificKind(applicationData?.[0]?.appl_kind_id),
    {
      enabled: !!applicationData?.[0]?.appl_kind_id,
    }
  );

  useEffect(() => {
    if (applicationData?.length > 0) {
      setDocumentsFiltered(
        documentsRequiredFiltered(
          docsPerKind,
          applicationData?.[0]?.nautical_pd_color
        )
      );
    }
  }, [docsPerKind, applicationData]);

  const { data: documents } = useQuery(
    ["applicationDocumentsWithIdExternalUser", id],
    () => fetchApplicationDocumentsExternalUser(id)
  );

  const tabs = [
    {
      tabName: t("Applicant details"),
      component: (
        <ApplicantDetails
          key={0}
          portAuthId={user?.port_auth_id}
          forMe={
            applicationData?.[0]?.afm_afora === applicationData?.[0]?.afm_ait
          }
          translatedGender={translatedGender}
          disableAll={
            // applicationData?.[0]?.status !== TEMPORARILY_SAVED ||
            applicationData?.[0]?.isService === SERVICE_SIDE ||
            applicationData?.[0]?.isService === NOONE_SIDE
          }
        />
      ),
    },
    {
      tabName: t("Documents"),
      component: (
        <UploadedDocuments
          initiallyUploadedDocuments={documents}
          docsPerKind={documentsFiltered}
          status={applicationData?.[0]?.status}
          id={id}
          disableAll={
            applicationData?.[0]?.isService === SERVICE_SIDE ||
            applicationData?.[0]?.isService === NOONE_SIDE
          }
        />
      ),
    },
    { tabName: t("Referrals"), component: <SeeReferrals id={id} /> },
    { tabName: t("Application History"), component: <SeeHistory id={id} /> },
    {
      tabName: t("eParavolo"),
      component: (
        <Eparavolo
          data={applicationData?.[0]}
          refetchUserApplicationData={refetchUserApplicationData}
        />
      ),
    },
  ];

  const docsPerKindFiltered = documentsRequiredFiltered(
    docsPerKind,
    nauticalPdColor
  );

  const initialValues = useMemo(() => {
    return generateInitialValues(
      id,
      applicationData,
      documents,
      TranslatedEducationLevel,
      TranslatedRetiredOptions,
      translatedGender,
      PrfcsData,
      PortAuthoritiesData,
      fetchBirthCountries
    );
  }, [
    id,
    applicationData,
    documents,
    PrfcsData,
    PortAuthoritiesData,
    fetchBirthCountries,
  ]);

  // if (applicationData) {
  //   // // console.log(applicationData?.[0]);
  // }
  // if (isLoadingApplication) {
  //   return (
  //     <div className={classes.loading}>
  //       <CircularProgress color="primary" />
  //     </div>
  //   );
  // }

  const disabledButtonSubmitForm =
    applicationData?.[0]?.isService === SERVICE_SIDE ||
    applicationData?.[0]?.isService === NOONE_SIDE ||
    !getIsEParavoloPliromeno(applicationData?.[0]);

  const handleSubmitApplication = (setFieldValue, submitForm) => {
    // // console.log("setFieldValue");
    // // console.log(setFieldValue);
    // // console.log("submitForm");
    // // console.log(submitForm);
    // // console.log("applicationData?.[0]?.status");
    // // console.log(applicationData?.[0]?.status);
    switch (applicationData?.[0]?.status) {
      case eParavoloAVathmias:
        setFieldValue("status", checkEParavoloAVathmias);
        break;
      case eParavoloBVathmias:
        setFieldValue("status", checkEParavoloBVathmias);
        break;
      case !applicationData?.[0]?.status:
        setFieldValue("status", INITIAL_SUBMIT);
        break;
      case applicationData?.[0]?.status === TEMPORARILY_SAVED:
        setFieldValue("status", INITIAL_SUBMIT);
        break;
      default:
        setFieldValue("status", RESUBMITTED);
        break;
    }
    // setFieldValue(
    //   "status",
    //   !applicationData?.[0]?.status ||
    //     applicationData?.[0]?.status === TEMPORARILY_SAVED
    //     ? INITIAL_SUBMIT
    //     : RESUBMITTED
    // );

    submitForm();
  };

  return (
    // We use EparavoloContentProvider to get to Formik the data from the eParavoloTab to submit them on backend
    <>
      <Helmet title={t("Edit Application")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Edit Application")}
      </Typography>
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>
        <Typography>{t("Edit Application")}</Typography>
      </Breadcrumbs>
      <Divider my={6} />
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={error}
      />
      <CustomAlert
        open={!!info}
        close={() => {
          setInfo("");
        }}
        message={info}
        severity="info"
      />
      <Formik
        enableReinitialize
        validationSchema={
          applicationData?.[0]?.afm_ait === applicationData?.[0]?.afm_afora
            ? getValidationSchemaForMe(t, docsPerKindFiltered, documents)
            : getValidationSchemaForOther(t, docsPerKindFiltered, documents)
        }
        initialValues={initialValues}
        onSubmit={onSubmit(setError, mutate, paravoloStatus)}
      >
        {({ submitForm, setFieldValue, errors, values }) => {
          // // console.log("errors");
          // // console.log(errors);
          // // console.log("values");
          // // console.log(values);
          // // console.log("statusAppl");
          // // console.log(statusAppl);f
          return (


            <>

              {statusAppl == INITIAL_SUBMIT ? (
                <>
                  <PostponeModal
                    open={isPostponeModalOpen}
                    message={
                      "You can fill in below any comments and desired dates for a new appointment"
                    }
                    submitAccept={() => {
                      // console.log("submitAccept");
                      setIsPostponeModalOpen(false);
                    }}
                    submitReject={() => {
                      // console.log("submitReject");
                      setFieldValue("rndv_from", null);
                      setFieldValue("rndv_to", null);
                      setFieldValue("status", RESUBMITTED);
                      submitForm();
                      setIsPostponeModalOpen(false);
                    }}
                  />
                  <Card className={classes.controlsContainer}>
                    {applicationData?.[0]?.rndv_from &&
                      applicationData?.[0]?.status !== FINISHED && (
                        <>
                          <Alert>
                            {`${t(
                              "For the issuing of your document, you can arrive on"
                            )} ${dayjs(applicationData?.[0]?.rndv_from).format(
                              "DD/MM/YYYY"
                            )} `}
                          </Alert>
                        </>
                      )}
                    <CardContent>
                      <Grid container direction="column">
                        <Grid container direction="row">
                          <Grid item xs={3}>
                            <div className={classes.insideContentMargin}>
                              <Typography
                                variant="subtitle2"
                                color="textSecondary"
                              >
                                {t("Application kind")}
                              </Typography>
                              <Typography variant="h4" gutterBottom>
                                {applicationData?.[0]?.applicationKind}
                              </Typography>
                            </div>
                          </Grid>
                          <Grid item xs={5}>
                            <div className={classes.insideContentMargin}>
                              <Typography
                                variant="subtitle2"
                                color="textSecondary"
                              >
                                {t("Status")}
                              </Typography>
                              <Typography variant="h4" gutterBottom>
                                {applicationData?.[0]?.applicationStatus}
                              </Typography>
                            </div>
                          </Grid>
                          <Grid item xs={2}>
                            <div className={classes.insideContentMargin}>
                              <Typography
                                variant="subtitle2"
                                color="textSecondary"
                              >
                                {t("Application date")}
                              </Typography>
                              <Typography variant="h4" gutterBottom>
                                {dayjs(applicationData?.[0]?.appl_dt).format(
                                  "DD/MM/YYYY"
                                )}
                              </Typography>
                            </div>
                          </Grid>
                          <Grid item xs={2}>
                            <div className={classes.insideContentMargin}>
                              <Typography
                                variant="subtitle2"
                                color="textSecondary"
                              >
                                {t("Application Protocol Number")}
                              </Typography>
                              <Typography variant="h4" gutterBottom>
                                {applicationData?.[0]?.reg_num || "-"}
                              </Typography>
                            </div>
                          </Grid>
                        </Grid>
                        <Grid container direction="row">
                          <Grid item xs={3}></Grid>
                          <Grid item xs={9}>
                            <div className={classes.insideContentMargin}>
                              <Typography
                                variant="subtitle2"
                                color="textSecondary"
                              >
                                {t("Last comments")}
                              </Typography>
                              <Typography variant="h4" gutterBottom>
                                {history?.[history?.length - 1]?.comments || "-"}
                              </Typography>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                  <Card>
                    <Grid
                      alignItems="center"
                      container
                      justifyContent="space-between"
                      className={classes.buttonContainer}
                      spacing={6}
                    >
                      {values.status !== FINISHED && (
                        <Grid item>
                          <GovGrButton
                            variant="warning"
                            disabled={
                              ((applicationData?.[0]?.status === REJECTED_FROM_CITIZEN) || (applicationData?.[0]?.status === APPROVED_AWAITING_COLLECTION))
                            }
                            onClick={() => {
                              setIsConfirmationModalOpen(true);
                            }}
                            buttonText={t("Cancel application")}
                          />

                          <ConfirmationModal
                            open={isConfirmationModalOpen}
                            message={
                              "Are you sure you want to cancel this application? This action cannot be undone and the progress of your application will be lost"
                            }
                            submitAccept={() => {
                              // console.log("canceled ");
                              setFieldValue("status", REJECTED_FROM_CITIZEN);
                              submitForm();
                            }}
                            submitReject={() => setIsConfirmationModalOpen(false)}
                          // submitAccept={() => {
                          //   // // console.log(REJECTED_FROM_CITIZEN);
                          //   setFieldValue("status", REJECTED_FROM_CITIZEN);
                          //   // /my-applications

                          //   setStatusAppl(REJECTED_FROM_CITIZEN);
                          //   setIsConfirmationModalOpen(false);
                          //   submitForm();
                          // }}
                          // submitReject={() => { // // console.log("submitReject"); // // console.log(REJECTED_FROM_CITIZEN); setIsConfirmationModalOpen(false) }}
                          />
                        </Grid>
                      )}
                      {applicationData?.[0]?.status == TEMPORARILY_SAVED && (
                        <Grid item>
                          <GovGrButton
                            variant="primary"
                            disabled={
                              applicationData?.[0]?.status ===
                              REJECTED_FROM_CITIZEN
                            }
                            onClick={async () => {
                              await setFieldValue("status", TEMPORARILY_SAVED);
                              // setStatusAppl(TEMPORARILY_SAVED);
                              submitForm();
                            }}
                            buttonText={t("Save")}
                          />
                        </Grid>
                      )}

                      {values.status == MEDICAL_A_DEGREE_REJECTION && (
                        <Grid item>
                          <GovGrButton
                            variant="primary"
                            onClick={() => {
                              setFieldValue("status", REVIEW);
                              submitForm();
                            }}
                            buttonText={"Αναθεώρηση"}
                          />
                        </Grid>
                      )}

                      <Grid item>
                        <GovGrButton
                          variant="primary"
                          onClick={async () => {
                            await setFieldValue("status", RESUBMITTED);
                            // // console.log("RESUBMITTED");
                            handleSubmitApplication(setFieldValue, submitForm);
                            setStatusAppl(RESUBMITTED);
                          }}
                          disabled={disabledButtonSubmitForm}
                          buttonText={t("Submit")}
                        />
                      </Grid>
                    </Grid>
                  </Card>
                  <Card>
                    <CardContent className={classes.applicationCard}>
                      {errors["uploadedDocuments"] &&
                        applicationData?.[0]?.status !== RESUBMITTED && (
                          <GovGrErrorSummary
                            errorsummary={[
                              { error: errors["uploadedDocuments"] },
                            ]}
                          />
                        )}

                      <GovGrTabs inputTable={tabs} />
                    </CardContent>
                  </Card>
                </>
              ) : (
                <>
                  <SuccessScreen
                    protocolNumber={applicationData?.[0]?.reg_num}
                    statusAppl={values.status}
                  />
                </>
              )}
            </>

          )
        }}
      </Formik>
    </>
  );
};

export default EditApplication;
